'use client';
import styled from 'styled-components';
import { Steps } from '../CheckoutHeader/styles';

export const Wrapper = styled.div`
  width: 100vw;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.background.base};
  ${Steps} {
    width: 100%;
  }
  @media ${({ theme }) => theme.tablet} {
    overflow: auto;
  }
`;

export const Headline = styled.h4`
  ${({ theme }) => theme.typography.heading4}
  ${({ theme }) => theme.fontFamily.condensed}
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: center;
  margin: ${({ theme }) => theme.spacing(2)};
`;

export const Subheadline = styled.h3`
  ${({ theme }) => theme.typography.heading3}
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const BodyText = styled.p`
  ${({ theme }) => theme.typography.body}
  text-align: center;
  color: ${({ theme }) => theme.colors.text.primary};
  @media ${({ theme }) => theme.tablet} {
    text-align: left;
    margin: 0;
  }
`;
export const LinkWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing(3, 0, 5)};
`;
export const StyledRecommendedPlanContainer = styled.div`
  padding: 0 5px;
  margin-bottom: ${({ theme }) => theme.spacing(34)};
  @media ${({ theme }) => theme.mobileM} {
    padding: 0 3.5%;
  }
`;

export const StyledRecommendedPlanCard = styled.div`
  background-color: ${({ theme }) => theme.colors.background.lightest};
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  max-width: 708px;
  min-width: 315px;
  border-radius: 32px;
  margin: 0 auto ${({ theme }) => theme.spacing(5)};
  padding: ${({ theme }) => theme.spacing(4, 5, 10)};
  @media ${({ theme }) => theme.tablet} {
    padding: ${({ theme }) => theme.spacing(4, 10, 3)};
  }
`;

export const StyledForm = styled.form``;
